import { searchContacts } from "../scoro/aggregateCalls";

export const searchContactsRoute = async (email) => {
  const data = await searchContacts(email);
  return data;
};
